import React from 'react';
import { NotificationsContainer} from '../../../notifications';
import { LayoutContainer } from '../../../video-layout-mode';
import AudioTracksContainer from '../../../video-layout-mode/components/AudioTracksContainer';

export default function ConferenceBody ({
    resize, roomCode, userAgentType, screenType, isTrackMode
}) {
    return (
        <div id="canvas_container" style={{ position: "relative", display: "flex", width: "100%", overflow: "hidden", flexDirection: "column", justifyContent: "flex-start",
            alignItems: "flex-start", background:"#1a1d25"}}>
            <LayoutContainer
                resize={resize}
                roomCode={roomCode}
                userAgentType={userAgentType}
                screenType={screenType}
                isTrackMode={isTrackMode}
            />
            <AudioTracksContainer />

            <NotificationsContainer />
        </div>
    );
}